'use strict';

if (document.querySelector('#references')) {
  // initialize references Object
  const references = {};
  // get references container
  references.container = document.querySelector('#references');
  // get category buttons
  references.categoryButtons = references.container.querySelectorAll('span.category');
  // get all references items
  references.items = references.container.querySelectorAll('.reference');
  // switch categories
  references.switchCategory = event => {
    // remove actual active state
    references.container.querySelector('span.category.active').classList.toggle('active');
    // set new active state
    event.target.classList.toggle('active');
    // call selectElements to show or hide chosen elements
    references.selectElements(event.target.dataset.category);
    return false;
  };
  references.selectElements = className => {
    // shows Elements by className
    references.items.forEach(item => {
      if (className === 'all') {
        item.style.display = 'block';
        return;
      }
      if (item.dataset.categories.includes(className)) {
        item.style.display = 'block';
      } else {
        item.style.display = 'none';
      }
    });
    return;
  };
  // watch category buttons for click
  references.categoryButtons.forEach(button => {
    button.addEventListener('click', references.switchCategory);
  });
}